import { render } from "./ParametersInput.vue?vue&type=template&id=71a9b26a&scoped=true"
import script from "./ParametersInput.vue?vue&type=script&lang=js"
export * from "./ParametersInput.vue?vue&type=script&lang=js"

import "./ParametersInput.vue?vue&type=style&index=0&id=71a9b26a&scoped=true&lang=css"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a9b26a"]])

export default __exports__